import { createAsyncThunk } from '@reduxjs/toolkit'
import ProcessedMediaStates from './processed-media-states-model'
import {
  delete_processedMediaStates,
  load_processedMediaStatess,
  store_processedMediaStates,
} from './processedMediaStates-service'

export const LoadProcessedMediaStatessAsync = createAsyncThunk<any, any>(
  'composer/load/processedMediaStates',
  async (params: { uid: string }) => {
    return await load_processedMediaStatess(params)
  },
)

export const CreateProcessedMediaStatesAsync = createAsyncThunk<any, any>(
  'composer/create/processedMediaStates',
  async (params: ProcessedMediaStates) => {
    return await store_processedMediaStates(params)
  },
)

export const DeleteProcessedMediaStatesAsync = createAsyncThunk<any, any>(
  'composer/delete/processedMediaStates',
  async (params) => {
    return await delete_processedMediaStates(params)
  },
)
